export const CONFERENCE = '/conference/' as const
export const CONFERENCE_ALL = `${CONFERENCE}all` as const
export const CONFERENCE_ARTICLE = `${CONFERENCE}article` as const
export const CONFERENCE_ARTICLE_BY_ID = `${CONFERENCE}article/` as const
export const CONFERENCE_ARTICLE_ALL = `${CONFERENCE}article/all` as const
export const CONFERENCE_CATEGORY_ALL = `${CONFERENCE}category/all` as const
